import React, { useEffect, useState } from "react"
import ModalCustom from "../../../../components/ModalCustom"

import PropTypes from "prop-types"

import "./index.less"
import { Input, Table } from "antd"
import { SearchOutlined } from "@ant-design/icons"

const GroupsModal = (props) => {
  const [searchedGroups, setSearchedGroups] = useState([])
  const [searchText, setSearchText] = useState("")

  const GROUPS_TABLE_COLUMNS = [
    {
      title: `${props.segment.name_segment_variable} (${
        props.segment.groups ? props.segment.groups.length : 0
      })`,
      dataIndex: "name_group",
      sorter: (a, b) => a.name_group.localeCompare(b.name_group),
    },
  ]

  useEffect(() => {
    setSearchedGroups(props.segment.groups)
  }, [props.segment])

  const onChangeSearch = (event) => {
    if (event.target.value.trim().length) {
      const copy = [...props.segment.groups]
      const search = copy.filter((value) =>
        value.name_group
          .toLowerCase()
          .includes(event.target.value.toLowerCase())
      )
      setSearchText(event.target.value)
      setSearchedGroups(search)
    } else {
      setSearchText(event.target.value)
      setSearchedGroups(props.segment.groups)
    }
  }

  return (
    <ModalCustom
      modalOpen={props.show}
      showOnlyAccept
      showFooter={false}
      title={`Segmento ${props.segment.name_segment}`}
      onOk={() => props.onOk()}
      onCancel={() => props.onOk()}>
      <Input
        style={{ width: "70%" }}
        placeholder="Buscar..."
        value={searchText}
        onChange={onChangeSearch}
        suffix={<SearchOutlined style={{ color: "#A7A3A3" }} />}
      />
      <Table
        style={{ marginTop: "20px" }}
        columns={GROUPS_TABLE_COLUMNS}
        scroll={{ y: 312 }}
        pagination={false}
        dataSource={searchedGroups}
      />
    </ModalCustom>
  )
}

GroupsModal.propTypes = {
  segment: PropTypes.object,
  show: PropTypes.bool,
  onOk: PropTypes.func,
}

export default GroupsModal
